import React from 'react';
import styled from 'styled-components';

import Typography from 'components/core/Typography/Typography';
import { Typographies } from 'models/uiElements';
import { CATEGORIES, CDN_IMAGES_URL } from 'consts';

interface IProps {
  category: string;
}

const DemoCreatePaymentModal = ({ category }: IProps) => {
  const textByCategory =
    category === CATEGORIES.card
      ? {
          title: 'Payment Successful',
          subtitle:
            'Upon successful payment, the customer will be redirected back to your website.'
        }
      : {
          title: 'Pending Payment Confirmation',
          subtitle:
            'Your customer receives detailed instructions to finalize the payment and complete the checkout process with the chosen payment method.'
        };

  return (
    <StyledModalWrapper>
      <StyledIcon src={`${CDN_IMAGES_URL}/clo-payment.svg`} />
      <Title name="demo-modal-title" type={Typographies.H5_HEADING}>
        {textByCategory.title}
      </Title>
      <SubTitle name="demo-modal-subtitle" type={Typographies.BODY1}>
        {textByCategory.subtitle}
      </SubTitle>
    </StyledModalWrapper>
  );
};

export default DemoCreatePaymentModal;

const StyledModalWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${({ theme }) => theme.colors.grey.grey100};
`;

const StyledIcon = styled.img`
  width: 4.8rem;
  height: 4.8rem;
`;

const Title = styled(Typography)`
  display: flex;
  justify-content: center;
  padding: 2rem 0;
`;

const SubTitle = styled(Typography)`
  display: block;
  text-align: center;
  padding: ${({ theme }) =>
    theme.view.isMobile ? '0 2rem 2rem 2rem' : '0 10rem 2rem 10rem'};
`;
